import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { getSelectedDate, getEarliestDate, getLatestDate, getStartDate, getEndDate, getIsPeriodIntraday } from "modules/security-profile/selectors/dates"
import { getOptions, getCategoryItemsSubset, getFilteredData } from "./selectors/data"
import { getDisplayType } from "./selectors/items"
import { computePositionSet, getSingleDateBase } from "modules/security-profile/helpers/security"
import { getFactorSensitivityType, getFirstFactorSensitivityDate } from "./selectors"
import { getDetails } from "./selectors/details"
import { getFactorSensitivityQueryParams } from "helpers/factorSensitivity"
import { getIsOpPro, getSelectedAccount } from "modules/account-root/selectors"
import { getThresholdParams } from "selectors/factorSensitivity"

const factorSensitivitySubQuery = "factors { id name category sensitivity }"

export default createModule({
  view,
  externalProps: (state, props) => ({
    account: getSelectedAccount(state),
    startDate: getStartDate(state),
    endDate: getEndDate(state),
    selectedDate: getSelectedDate(state),
    factorSensitivityType: getFactorSensitivityType(state, props),
    isPeriodIntraday: getIsPeriodIntraday(state, props),
  }),
  required: ["account", "modelId"],
  data: [{
    resource: "securityFactorSensitivity",
    url: ({ modelId, security: { assetClass, ticker, mic, modelProviderId }, base, startDate, endDate, factorSensitivityType, isPeriodIntraday }) => {
      const positionSetDate = isPeriodIntraday ? endDate : startDate
      const positionSet = {
        dates: [{
          date: positionSetDate,
          ...computePositionSet(assetClass, ticker, mic, modelProviderId),
        }],
      }
      const normalizedBase = getSingleDateBase(base, positionSetDate)
      const queryParams = getFactorSensitivityQueryParams(factorSensitivityType, { isPeriodIntraday })

      if (isPeriodIntraday) {
        return {
          id: `securityFactorSensitivity-intraday-${modelId}${ticker}${mic}${endDate}${factorSensitivityType}${JSON.stringify(normalizedBase)}`,
          query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $endDate: Date!, $factorSensitivityType: FactorSensitivityType!, $horizon: FactorSensitivityTimeHorizon!, $stdDev: PositiveFloat, $days: PositiveInt) {
            model (id: $modelId) {
              intradaySimulation(positionSet: $positionSet, base: $base, on: $endDate) {
                factorSensitivity(type: $factorSensitivityType, horizon: $horizon, stdDev: $stdDev, days: $days) {
                  date: timestamp
                  ${factorSensitivitySubQuery}
                }
              }
            }
          }`,
          variables: {
            modelId,
            positionSet,
            base: normalizedBase,
            endDate,
            ...queryParams,
          },
        }
      }

      return {
        id: `securityFactorSensitivity-${modelId}${ticker}${mic}${startDate}${endDate}${factorSensitivityType}${JSON.stringify(normalizedBase)}`,
        query: `query ($modelId: String!, $positionSet: PositionSetInput!, $base: [PositionSetInput], $startDate: Date!, $endDate: Date!, $factorSensitivityType: FactorSensitivityType!, $horizon: FactorSensitivityTimeHorizon!, $stdDev: PositiveFloat, $days: PositiveInt) {
          model (id: $modelId) {
            simulation(positionSet: $positionSet, base: $base, from: $startDate, to: $endDate, interval: AUTO) {
              factorSensitivity(type: $factorSensitivityType, horizon: $horizon, stdDev: $stdDev, days: $days) {
                date
                ${factorSensitivitySubQuery}
              }
            }
          }
        }`,
        variables: {
          modelId,
          positionSet,
          base: normalizedBase,
          startDate,
          endDate,
          ...queryParams,
        },
      }
    },
  }],
  mapStateToProps: state => ({
    earliestDate: getEarliestDate(state),
    latestDate: getLatestDate(state),
    data: getFilteredData(state),
    items: getCategoryItemsSubset(state),
    options: getOptions(state),
    details: getDetails(state),
    firstDate: getFirstFactorSensitivityDate(state),
    ...state.modules.securityProfileFactorSensitivity,
    displayType: getDisplayType(state),
    isOpPro: getIsOpPro(state),
    thresholdParams: getThresholdParams(state),
  }),
  actions: {
    ...Creators,
    setDate: PortfolioRootCreators.setProfileDate,
    resetDate: PortfolioRootCreators.resetProfileDate,
    openFactorProfile: ProfileCreators.openFactorProfile,
  },
})
